import CampoSeletor from '../../components/Formulario/CampoSeletor';

type FiltroOrigemAtendimentoProps = {
    value: string;
    onChange: (value: string) => void;
};

const options = [
    { id: '', label: 'Todas as mensagens' },
    { id: 'atendimento', label: 'Somente durante atendimento' },
    { id: 'chatbot', label: 'Somente chatbot' },
];

export const FiltroOrigemAtendimento = ({ value, onChange }: FiltroOrigemAtendimentoProps) => {
    return (
        <CampoSeletor
            noSearch
            label="Período"
            options={options}
            value={value}
            onChange={v => onChange(v ?? '')}
        />
    );
};
